import { IPageLevelRuleClient } from "@presentation/FormBuilder/components/ConfiguredRule/interface";

import { FieldProps, FormModes } from "@presentation/FormBuilder/components/FormFieldSelector/interfaces";
import {
  IFieldLevelRuleConditionClient,
  IFormLevelRuleClient,
  IFormServer,
  IPageLevelRuleAction,
  IFieldLevelRuleConditionMap,
  IFieldLevelRuleActionServer,
  IFieldLevelRuleClient,
  IPageLevelRuleConditionMap,
  IPageLevelRuleConditionClient,
  IFormLevelRuleConditionClient,
  IFormLevelRuleActionServer,
  ISubmissionLevelRuleConditionClient,
  ISubmissionLevelRuleActionServer,
  ISubmissionLevelRuleConditionMap,
  ISubmissionLevelRuleClient,
} from "../forms/interface";
import { IFieldLevelRuleConditionServer } from "@presentation/FormBuilder/components/ConfiguredRule/interface";
import { IFieldSubmissionMap } from "@erelego/design-system/interface/Forms/formSubmissionInterface";
import { OtpMethodValue } from "@presentation/Forms/Components/FormSetting/FormValidation/utils";
import { IOption } from "@erelego/design-system/components/atoms/DropdownSelect";
export interface IForm {
  isMultipleForm?: boolean;
  themeId?: string;
  activeSubformIndex?: number;
  form_db_name?: string;
  name: string;
  title?: string;
  description?: string;
  formLogo?: string;
  fieldsMap: IFieldsMap;
  overviewForm: string[];
  subForms: string[];
  subFormsMap: ISubFormsMap | any;
  activeFormStep?: number;
  css?: any;
  localId?: string;
  settings?: Isettings;
  roles?: Iroles[];
  selectedRole?: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  permission?: {};
  isDisabled?: boolean;
  updatedDate?: string;
  createdDate?: string;
  isAnonymousSubAllowed?: boolean;
  relatedFormIds?: string[];
  isOverviewAllowed?: boolean;
  isReSubmissionAllowed?: boolean;
  isDraftViewAllowed?: boolean;
  isApprovalRequired?: boolean;
  approvalFieldId?: string;
  isMultipleSubAllowed?: boolean;
  sendEmailAlerts?: boolean;
  enableFieldNumbering?: boolean;
  folderPath?: string;
  submissionDeadline?: ISubmissionDeadline;
  applicationId?: string;
  environment?: string;
  enableSectionShowOrHide?: boolean;
  isSectionShowOrHide?: string;
  visibility?: visibilityType;
  isCompositeKeyEnabled?: boolean;
  deleteActionRequired?: boolean;
  isSearchRequired?:boolean;
  isReferenceByFieldsMap?: boolean;
  rowActionsRequired?: boolean;
  compositeKeyFields?: [];
  isQrCodeRequired?: boolean;
  qrCodeRefField?: string;
  qrCodeRefPageIds?: string;
  dateRangeEnabled?: boolean;
  isWeekendDisabled?: boolean;
  specificDateSelectionEnabled?: boolean;
  specificDateRangeEnabled?: boolean;
  jsonApiEnabled?: boolean;
  preDisableDateCount?: string;
  postDisableDateCount?: string;
  specificDates?: [];
  specificDateRange?: [];
  dateJsonApiUrl?: string;
  slotDuration?: string;
  slotSetting?: ISlotSetting;
  dateReferralFieldId?: string;
  isPartOfTimeSlot?: boolean;
  isFormLocked?: boolean;
  formLockedBy?: IFormLockedBy;
  isTemplate?: boolean;
  customSuccessMessage?: string;
  customUpdateSuccessMessage?: string;
  isCurrentDateSelected?: boolean;
  dateInitialValueType?: string;
  isCurrentTimeSelected?: boolean;
  timeInitialValueType?: string;
  isCurrentDateTimeSelected?: boolean;
  dateTimeInitialValueType?: string;
  fromFieldId?: string;
  toFieldId?: string;
  fromTimeFieldId?: string;
  toTimeFieldId?: string;
  fieldCount?: number;
  isPastDateDisabled?: boolean;
  isRegularTimeFormat?: boolean;
  hideFromVisiblity?: boolean;
  generateSequenceByWorkflow?: boolean;
  isMultiFormVertical?: boolean;
  defaultValue?: number;
  isTimeOfDayRequired?: boolean;
  timeOfDayFieldId?: string;
  isMonthDisplayRequired?:boolean;
  monthDisplayFieldId?: string;
  timeOfDayConfig?: ITimeOfDayConfig[];
  isValidationRequiredbeforeSubmission?: boolean;
  isScriptOnFormSubmission?: boolean;
  scriptOnSubmission?: string;
  validationModal?: boolean;
  otpModal?: boolean;
  otpMethod?: OtpMethodValue | string;
  otpMethodValue? : IOption;
}

export interface ITimeOfDayConfig {
  label: string;
  startTime: string;
  endTime: string;
}


export interface ISlotSetting {
  daySlotTimings?: string[];
  isChecked?: boolean;
}
export enum visibilityType {
  "PRIVATE" = "PRIVATE",
  "PUBLIC" = "PUBLIC",
}
export interface ISubForm {
  localId: string;
  title: string;
  name: string;
  description: string;
  fields: string[];
  position: number;
  enableSectionShowOrHide?: boolean;
  isSectionShowOrHide?: string;
  isFormLocked?: boolean;
  formLockedBy?: IFormLockedBy;
}

export interface IFormBuilderState {
  activeForm: IForm;
  activeRules?: IAdvancedRulesClient;
  activeSubformIndex?: number;
  fieldLoaderMap: IFieldLoaderMap;
  // eslint-disable-next-line @typescript-eslint/ban-types
  loaders: {};
  // eslint-disable-next-line @typescript-eslint/ban-types
  errors: {};
  submissionType?: submisionType;
  currentEditModeFieldId: string;
  currentFocusedFieldId: string;
  activeFormIsEditing: boolean;
  updatedHiddenFields: any;
  formLockData: IFormLockData;
  isMultiFormVertical: boolean;
  formMode: FormModes
}

export interface IAdvancedRulesClient {
  formId: string;
  fieldRules: IFieldLevelRuleClient[];
  pageRules: IPageLevelRuleClient[];
  formRules: IFormLevelRuleClient[];
  submissionRules: ISubmissionLevelRuleClient[];
  fieldConditionMap?: IFieldLevelRuleConditionMap;
  pageConditionMap?: IPageLevelRuleConditionMap;
  formConditionMap?: IFormLevelRuleConditionMap;
  submissionConditionMap?: ISubmissionLevelRuleConditionMap;
  fieldsToIgnore?: string[];
  subFormToIgnore?: string[];
  formFieldsToIgnore?: string[];
  activeFieldRuleCount?: number;
  activePageRuleCount?: number;
  activeFormRuleCount?: number;
  activeSubmissionRuleCount?: number;
  activeFieldRuleIndex?: number;
  activePageRuleIndex?: number;
  activeFormRuleIndex?: number;
  activeSubmissionRuleIndex?: number;
  fieldsToHideAndShow: IFieldsToHIdeAndShow;
  pageToHideAndShow: IPageToHIdeAndShow;
  modalData?: IModalData;
}
export interface IFormLevelRuleConditionMap {
  [conditionId: string]: IFormLevelRuleConditionClient;
}
export interface IFieldRulesMap {
  [conditionId: string]: IFieldLevelRuleConditionClient;
}
export interface IFieldLoaderMap {
  [conditionId: string]: boolean;
}
export interface IAdvancedRulesServer {
  formId: string;
  fieldRules: IFieldLevelRuleServer[];
  pageRules: IPageLevelRuleServer[];
  formRules: IFormLevelRuleServer[];
  submissionRules: ISubmissionLevelRuleServer[];
}

export interface IFieldLevelRuleServer {
  ruleName?: string;
  logicalOperator?: string;
  conditions?: IFieldLevelRuleConditionServer[];
  action?: IFieldLevelRuleActionServer;
}
export interface IPageLevelRuleServer {
  ruleName: string;
  logicalOperator?: string;
  conditions: IFieldLevelRuleConditionClient[];
  action: IPageLevelRuleAction;
}

export interface IFormLevelRuleServer {
  ruleName: string;
  logicalOperator?: string;
  conditions: IFieldLevelRuleConditionClient[];
  formAction?: IFormLevelRuleActionServer[];
}

export interface ISubmissionLevelRuleServer {
  ruleName: string;
  logicalOperator?: string;
  conditions: ISubmissionLevelRuleConditionClient[];
  submissionAction?: ISubmissionLevelRuleActionServer;
}

export interface IFieldsMap {
  [fieldId: string]: FieldProps;
}

export interface ISubFormsMap {
  [subFormId: string]: ISubForm;
}

export interface Isettings {
  roles?: any;

  selectedRole: string;
}

export interface Iroles {
  id?: string;
  title?: string;
}

export interface IFormMultileOption {
  index?: number;
  currentOptionFields: any;
}
export interface IShowFieldEditorActionSelector {
  fieldId: string;
  showFieldEditor?: boolean;
}

export interface IUpdateIsFocusAction {
  fieldId: string;
  isFieldFocused?: boolean;
}

export interface IPopulateNewFieldConfig {
  fieldId?: string;
  fieldConfig: FieldProps;
}

export interface IPopulateNewSectionConfig {
  sectionId?: string;
  sectionConfig: FieldProps;
}

export interface ISubmissionDeadline {
  startDate: number;
  endDate: number;
  isDeadlineEnabled: boolean;
  isDynamicDeadlineEnabled: boolean;
  dynamicDeadlineFieldId?: string;
}

export interface ISetActiveFormAction {
  type: string;
  payload: {
    formData: IFormServer;
  };
}

export interface IChangeFieldPositionActionPayload {
  draggedFieldPosition: number;
  dropFieldPosition: number;
  dragFormId: string;
  dropFormId: string;
}

export interface IChangeFieldPositionAction {
  type: string;
  payload: IChangeFieldPositionActionPayload;
}

export interface IUpdateFieldRulePayload {
  position: number;
  fieldRule: IFieldLevelRuleClient;
}
export interface IUpdatePageRulePayload {
  position: number;
  pageRule: IPageLevelRuleClient;
}
export interface IUpdateFormRulePayload {
  position: number;
  formRule: IFormLevelRuleClient;
}

export interface ISetActiveRuleAction {
  type: string;
  payload: {
    ruleData: IAdvancedRulesServer;
  };
}

export interface IAddFieldConditionAction {
  position: number;
  parentConditionId: string;
  fieldConditionData: IFieldLevelRuleConditionClient;
}
export interface IAddPageConditionAction {
  position: number;
  parentConditionId?: string;
  pageConditionData: IPageLevelRuleConditionClient;
}

export interface IAddFormConditionAction {
  position: number;
  parentConditionId?: string;
  formConditionData: IFormLevelRuleConditionClient;
}

export interface IAddSubmissionConditionAction {
  position: number;
  parentConditionId?: string;
  submissionConditionData: ISubmissionLevelRuleConditionClient;
}
export interface IDeleteSubmissionConditionAction {
  position: number;
  parentConditionId?: string;
}

export interface IUpdateSubmissionRulePayload {
  position: number;
  submissionRule: ISubmissionLevelRuleClient;
}

export interface IDeletePageConditionAction {
  position: number;
  parentConditionId?: string;
}

export interface IDeleteFormConditionAction {
  position: number;
  parentConditionId?: string;
}
export interface IDeleteFieldConditionAction {
  position: number;
  parentConditionId: string;
}

export interface IUpdateFieldsToIgnoreActionPayload {
  oldFieldId: string;
  newFieldId: string;
}
export interface IUpdatePagesToIgnoreActionPayload {
  oldPageId: string;
  newPageId: string;
}

export interface IUpdateFormFieldsToIgnoreActionPayload {
  oldFormId: string;
  newFormId: string;
}
export interface IAddNewSubRuleAction {
  position: number;
  parentConditionId: string;
}

export interface IValidateFieldRule {
  type: string;
  payload: {
    submissionType: submisionType;
    fieldId: string;
    submissionId?: string;
    submissionMap?: IFieldSubmissionMap;
  };
}
export interface ISetActiveSubmissionTypeAction {
  type: string;
  payload: { submissionType: submisionType };
}
export enum submisionType {
  "SUBMISSION" = "SUBMISSION",
  "RESUBMISSION" = "RESUBMISSION",
}
export interface IFieldsToHIdeAndShow {
  hide: string[];
  show: string[];
  disabled?: string[];
}

export interface IPageToHIdeAndShow {
  show: string[];
  hide?: string[];
  skip: string[];
  elseSkip?: string[];
}
export interface IModalData {
  content: string;
  type: string;
  visibility;
}
export interface ICopySectionActionPayload {
  index: number;
  newSectionId: string;
  parentFormId: string;
  formId: string;
}
export interface IFieldIndex {
  [data: string]: string;
}

export interface IAutoSaveFormLocallyAction {
  type: string;
  payload: {
    isSaved: boolean;
  };
}
export interface IPageData {
  id: string;
  name: string;
  applicationId: string;
  moduleId: string;
  type: string;
  createdDate: string;
  createdBy: string;
  lastUpdatedDate: number;
  lastUpdatedBy: string;
  formIds: string;
  environment: string;
  isDraft: boolean;
  version: string;
  jsonPath: string;
  isPageLocked: false;
  pageLockedBy: string;
  visibilityType: string;
  showSidePanel: boolean;
  linkedPages: string;
  archived: boolean;
}
export interface IFetchApplicationPayload {
  applicationId: string;
  onSuccess: (data: IPageData[]) => void;
  onFailure: (error: string) => void;
}
export interface IFetchApplicationPage {
  type: string;
  payload: IFetchApplicationPayload;
}

export interface ISetFormMode {
  type: string;
  payload: FormModes;
}

export interface ISetAutoSavedFormToFormbuilder {
  type: string;
  payload: {
    formData: IForm;
  };
}

export interface ISetFormIsEditingAction {
  type: string;
  payload: {
    isEditing: boolean;
  };
}

export interface ICompositeKeyFields {
  content: string;
  value: string;
}

export interface IGetSignatureFormFilesAction {
  type: string;
  payload: IGetSignatureFormFilesActionPayload;
}

export interface IGetSignatureFormFilesActionPayload {
  signatureID: string;
  onSuccessFileFetch: (response: FileSuccessPayload) => void;
  onFailureFileFetch: (ErrorText: string) => void;
}

export interface FileSuccessPayload {
  file: string;
  signatureID: string;
}

export interface IFormLockData {
  formId: string;
  isFormLocked: any;
  formLockedBy?: any;
}

export interface IIsFormLocked {
  [formId: string]: boolean;
}
export interface IFormLockedByData {
  [formId: string]: IFormLockedBy;
}

export interface IFormLockedBy {
  userId: string;
  userName: string;
  email: string;
}

export interface IUpdateFormLockData {
  type: string;
  payload: IFormLockPayload;
}

export interface IFormLockPayload {
  formLockData: IFormLockData;
}
